module.exports = __webpack_public_path__ + "static/media/logo-purple.73767721.svg";